/**
 *  @function evalute - evaluate dateDiffBehavior
 */

const {
  evaluateSource
} = require('../lib/evaluateSource');

// example of local module included within a config-js release
const {
  dateDiffInSeconds
} = require('./shared/dateDiff');
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const fromDate = await evaluateSource(source.fromDate, content, parentContentPath, transientContext, nativeFunctions);
  const toDate = await evaluateSource(source.toDate, content, parentContentPath, transientContext, nativeFunctions);
  return dateDiffInSeconds(toDate, fromDate);
};
module.exports = {
  evaluate
};